import { render, staticRenderFns } from "./AnnouncementsAlert.vue?vue&type=template&id=b6fbf19e&scoped=true&"
import script from "./AnnouncementsAlert.vue?vue&type=script&lang=js&"
export * from "./AnnouncementsAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6fbf19e",
  null
  
)

export default component.exports